const addPxIfNumber = x =>
  typeof x === 'number' ? `${x}px` : x

export default addPxIfNumber
